module.exports = __webpack_public_path__ + "static/media/avery-tucker.3b7646f4.jpeg";